'use client';
import { useEffect, useState } from 'react';
import { useTranslations as useTranslations$1 } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Download, X } from '@/components/ui/icons';
import { getDesktopUpdatePromptInfo, type DesktopUpdatePromptInfo } from '@/lib/desktopUpdatePrompt';
const STORAGE_KEY = 'martini-desktop-update-prompt-dismissed-at';
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;
function isDismissed(): boolean {
    try {
        const dismissedAt = Number(window.localStorage.getItem(STORAGE_KEY));
        return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < DISMISS_DURATION_MS;
    } catch  {
        return false;
    }
}
function rememberDismissal() {
    try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch  {
    // Ignore storage failures; dismissing for the current session still works.
    }
}
export function DesktopUpdatePrompt() {
    const t = useTranslations$1();
    const [info, setInfo] = useState<DesktopUpdatePromptInfo | null>(null);
    useEffect(()=>{
        const timer = window.setTimeout(()=>{
            const nextInfo = getDesktopUpdatePromptInfo(window.navigator.userAgent);
            if (nextInfo && !isDismissed()) setInfo(nextInfo);
        }, 0);
        return ()=>window.clearTimeout(timer);
    }, []);
    if (!info) return null;
    const handleDismiss = ()=>{
        rememberDismissal();
        setInfo(null);
    };
    const isExternalDownload = info.downloadUrl.startsWith('http');
    return (<div className="fixed inset-x-3 bottom-3 z-[1000] sm:left-auto sm:right-4 sm:w-[360px]">
      <div className="rounded-md border border-border bg-popover p-3 text-foreground shadow-lg">
        <div className="flex items-start gap-3">
          <Download className="mt-0.5 h-4 w-4 flex-none text-muted-foreground"/>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{t("DgYSCc")}</p>
            <p className="mt-1 text-xs text-muted-foreground">{t("jz3yDn")}</p>
          </div>
          <button type="button" aria-label={t("TDaF6J")} onClick={handleDismiss} className="flex h-6 w-6 flex-none items-center justify-center rounded text-muted-foreground hover:bg-secondary hover:text-foreground">
            <X className="h-3.5 w-3.5"/>
          </button>
        </div>
        <div className="mt-3 flex justify-end">
          <Button asChild size="sm" className="h-8 text-xs">
            <a href={info.downloadUrl} target={isExternalDownload ? '_blank' : undefined} rel={isExternalDownload ? 'noreferrer' : undefined}>
              <Download className="h-3.5 w-3.5"/>
              {t("BWpuKl")}
            </a>
          </Button>
        </div>
      </div>
    </div>);
}
